module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA2AQMAAAALaq7rAAAABlBMVEXnAAD///+umLTnAAAAGklEQVQoz2NgGBCQQA0e/3/cPOrYMAqGIwAA1QYF3QBhZOgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/btn-add-score.png
// module id = 16
// module chunks = 0